// Utility to format date
function $55e824ff15c161b3$var$formatDate(timeStamp) {
    const date = new Date(timeStamp);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}
function $55e824ff15c161b3$export$9a00dee1beb8f576(input) {
    const trimmed = input.trim();
    if (trimmed.includes(' ')) {
        const mulWords = trimmed.split(' ').map((word)=>{
            return `${word.slice(0, 1).toUpperCase()}${word.slice(1)}`;
        });
        return mulWords.join(' ');
    } else return `${trimmed.slice(0, 1).toUpperCase()}${trimmed.slice(1)}`;
}
function $55e824ff15c161b3$export$7d4e79dfece53960(input) {
    const trimmed = input.trim();
    return `${trimmed.slice(0, 1).toUpperCase()}${trimmed.slice(1)}`;
}
function $55e824ff15c161b3$export$c4fcf078ecfbfb48(date) {
    const days = Math.floor(Math.abs(Date.now() - date) / 86400000);
    if (days === 1) return 'YESTERDAY';
    if (days === 0) return 'TODAY';
    if (days > 1 && days <= 30) return `${days} DAYS AGO`;
    if (days > 30) return $55e824ff15c161b3$var$formatDate(date);
}


console.log('Model.js');
let $7b94c335d9c1ff80$export$ca000e230c0caa3e = {
    selectedSpace: null,
    selectedTab: 'all',
    selectedTask: null,
    spaces: [],
    tasks: []
};
function $7b94c335d9c1ff80$export$1f73f60bdb811cb1() {
    localStorage.setItem('state', JSON.stringify($7b94c335d9c1ff80$export$ca000e230c0caa3e));
}
function $7b94c335d9c1ff80$export$d3720feff416e85b() {
    return JSON.parse(localStorage.getItem('state'));
}
// Init local storage
if (localStorage.length === 0) $7b94c335d9c1ff80$export$1f73f60bdb811cb1();
else $7b94c335d9c1ff80$export$ca000e230c0caa3e = $7b94c335d9c1ff80$export$d3720feff416e85b();
function $7b94c335d9c1ff80$export$f03cab61d61a42f0(value, num) {
    const trimmed = value.trim().toLowerCase();
    if (trimmed.length === 0) return {
        valid: null,
        msg: `Not more than ${num} chars`
    };
    if (trimmed.length > num) return {
        valid: false,
        msg: `Should be <= ${num} chars`
    };
    if ($7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces.some((item)=>item.name.toLowerCase() === trimmed)) return {
        valid: false,
        msg: `${trimmed} already exits`
    };
    return {
        valid: true,
        msg: `Not more than ${num} chars`
    };
}
function $7b94c335d9c1ff80$export$776c9bc84f6ac10(value, num) {
    let array = [];
    const trimmed = value.trim().toLowerCase();
    if ($7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.length) array = $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.filter((task)=>task.space === $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace);
    if (trimmed.length === 0) return {
        valid: null,
        msg: `Not more than ${num} chars`
    };
    if (trimmed.length > num) return {
        valid: false,
        msg: `Should be <= ${num} chars`
    };
    if (array.length && array.some((item)=>item.name.toLowerCase() === trimmed)) return {
        valid: false,
        msg: `${trimmed} already exits`
    };
    return {
        valid: true,
        msg: `Not more than ${num} chars`
    };
}




console.log('Space Model');
function $8a68e8e5f5b6a7df$export$c672d36cc05d8a31(newSpace) {
    const exists = $7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces.some((space)=>space.name.toLowerCase() === newSpace.toLowerCase());
    if (exists) return false;
    $7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces.push({
        name: $55e824ff15c161b3$export$9a00dee1beb8f576(newSpace),
        time: Date.now()
    });
    $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace = $55e824ff15c161b3$export$9a00dee1beb8f576(newSpace);
    $7b94c335d9c1ff80$export$1f73f60bdb811cb1();
    return $7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces;
}
function $8a68e8e5f5b6a7df$export$cfcf789129734d0c(DOMel) {
    const spaceNameEl = DOMel.querySelector('.space--name');
    $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace = spaceNameEl.textContent;
    $7b94c335d9c1ff80$export$1f73f60bdb811cb1();
}




console.log('Task Module');
function $8b9580027b625b19$export$210cf76140947b0c(newTask) {
    const selectedArray = $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.filter((item)=>item.space === $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace);
    const exists = selectedArray.some((task)=>task.name === $55e824ff15c161b3$export$7d4e79dfece53960(newTask));
    if (exists) return false;
    $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.unshift({
        // ID : ### Fix me later ###
        id: Date.now(),
        name: $55e824ff15c161b3$export$7d4e79dfece53960(newTask),
        time: Date.now(),
        archived: false,
        completed: false,
        space: $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace,
        edited: false
    });
    $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedTab = 'all';
    $7b94c335d9c1ff80$export$1f73f60bdb811cb1();
    return $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks;
}
function $8b9580027b625b19$export$4b713e253325a1b6() {
    return $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.filter((item)=>item.space === $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace);
}
function $8b9580027b625b19$export$6937fadb06c56e4c(oldSpaceName, newSpaceName) {
    console.log(oldSpaceName, newSpaceName);
    if (newSpaceName.length > 25 || newSpaceName.length === 0) {
        alert(`${newSpaceName} is not a valid space name`);
        return;
    }
    const alreadyExists = $7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces.some((space)=>space.name === newSpaceName);
    if (alreadyExists) {
        alert(`${newSpaceName} already exists in spaces`);
        return;
    }
    const selSpace = $7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces.find((space)=>space.name === oldSpaceName);
    const spaceTasks = $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.filter((task)=>task.space === oldSpaceName);
    selSpace.name = newSpaceName;
    spaceTasks.forEach((task)=>task.space = newSpaceName);
    $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace = newSpaceName;
    $7b94c335d9c1ff80$export$1f73f60bdb811cb1();
}
function $8b9580027b625b19$export$9f2575a093d7aa7b(selecedTab) {
    $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedTab = selecedTab;
    $7b94c335d9c1ff80$export$1f73f60bdb811cb1();
}
function $8b9580027b625b19$export$d1f442602a91e7cc() {
    const selectedArray = $8b9580027b625b19$export$4b713e253325a1b6();
    const allList = selectedArray.filter((item)=>!item.completed && !item.archived);
    return allList;
}
function $8b9580027b625b19$export$461260a351dd1159() {
    const selectedArray = $8b9580027b625b19$export$4b713e253325a1b6();
    const pendingList = selectedArray.filter((item)=>!item.completed);
    return pendingList;
}
function $8b9580027b625b19$export$7a201e616c9e1a4d() {
    const selectedArray = $8b9580027b625b19$export$4b713e253325a1b6();
    const completedList = selectedArray.filter((item)=>item.completed);
    return completedList;
}
function $8b9580027b625b19$export$ecd6bf12cc32669b() {
    const selectedArray = $8b9580027b625b19$export$4b713e253325a1b6();
    const archivedList = selectedArray.filter((item)=>!item.completed && item.archived);
    return archivedList;
}
function $8b9580027b625b19$export$ade48d0de42a8766(taskName, property) {
    const activeTask = $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.find((item)=>item.name === taskName && item.space === $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace);
    if (activeTask) activeTask[property] = !activeTask[property];
    $7b94c335d9c1ff80$export$1f73f60bdb811cb1();
    return activeTask[property];
}
function $8b9580027b625b19$export$f08d315250e1aa23(taskName) {
    const feedback = confirm(`You are deleting "${taskName}" task!`);
    if (!feedback) return;
    const activeTask = $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.findIndex((item)=>item.name === taskName && item.space === $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace);
    $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.splice(activeTask, 1);
    $7b94c335d9c1ff80$export$1f73f60bdb811cb1();
    return activeTask;
}
function $8b9580027b625b19$export$7929b2426b44fc90(oldTaskName, newTaskName) {
    const trimmed = $55e824ff15c161b3$export$7d4e79dfece53960(newTaskName.trim());
    if (trimmed.length > 250 || trimmed.length === 0) {
        alert(`"${trimmed}" is an invalid task name!`);
        return;
    }
    const spaceTasks = $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks.filter((item)=>item.space === $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace);
    if (spaceTasks.some((task)=>task.name === newTaskName)) return alert('task already exits');
    const oldTask = spaceTasks.find((item)=>item.name === oldTaskName);
    oldTask.name = newTaskName;
    oldTask.edited = true;
    $7b94c335d9c1ff80$export$1f73f60bdb811cb1();
}



const $efdbc318bab6ae71$var$taskList = document.querySelector('.task-list');
const $efdbc318bab6ae71$export$965f107e1da09ee7 = function(tasks) {
    $efdbc318bab6ae71$var$taskList.innerHTML = '';
    if (!tasks) return;
    tasks.forEach((task, index)=>{
        const li = document.createElement('li');
        li.innerHTML = `
                  <div>
                    <span class="left">
                      <div class="circle done" title="complete">
                      <span><i class="fa-solid fa-check tick"></i></span>
                      </div>

                      <p class="task-name" contenteditable="true" >
                        ${$55e824ff15c161b3$export$7d4e79dfece53960(task.name)}
                      </p>
                    </span>
                    <div class="task--details">
                      <p class="date">
                      <i class="fa-regular fa-clock"></i>${$55e824ff15c161b3$export$c4fcf078ecfbfb48(task.time)}
                      </p>
                      <p class=${task.edited ? 'tag' : 'hidden'}>Edited</p>
                    </div>
                  </div>
                  <div class="right">
                    <div class="circle archive" title="archive"></div>
                    <div class="circle delete" title="delete"></div>
                  </div>
    `;
        li.classList.add('task', `${index}`);
        $efdbc318bab6ae71$var$taskList.appendChild(li);
    });
};



// DOM selections
const [$a37d928ba35fa9ba$var$openFormBtn, $a37d928ba35fa9ba$var$addFormBtn] = document.querySelectorAll('.btn--1');
const [$a37d928ba35fa9ba$var$spaceOverlay, $a37d928ba35fa9ba$var$taskOverlay] = document.querySelectorAll('.overlay');
const $a37d928ba35fa9ba$var$form = document.querySelector('.form');
const $a37d928ba35fa9ba$var$input = document.querySelector('.space--input');
const $a37d928ba35fa9ba$var$validText = document.querySelector('.space-text');
const $a37d928ba35fa9ba$var$spacesList = document.querySelector('.spaces--list');
const $a37d928ba35fa9ba$var$rightPane = document.querySelector('.right--pane');
const $a37d928ba35fa9ba$var$leftPane = document.querySelector('.left--pane');
const $a37d928ba35fa9ba$var$backwards = document.querySelector('.backwards');
function $a37d928ba35fa9ba$export$22bab4bbe1f35723() {
    $a37d928ba35fa9ba$var$addFormBtn.classList.remove('hidden');
    $a37d928ba35fa9ba$var$openFormBtn.classList.add('hidden');
    $a37d928ba35fa9ba$var$form.classList.replace('hidden', 'block-space-input');
    $a37d928ba35fa9ba$var$spaceOverlay.classList.remove('hidden');
    $a37d928ba35fa9ba$var$input.focus();
}
function $a37d928ba35fa9ba$export$ae0ccaae42dee9bc() {
    $a37d928ba35fa9ba$var$addFormBtn.classList.add('hidden');
    $a37d928ba35fa9ba$var$openFormBtn.classList.remove('hidden');
    $a37d928ba35fa9ba$var$form.classList.replace('block-space-input', 'hidden');
    $a37d928ba35fa9ba$var$spaceOverlay.classList.add('hidden');
}
function $a37d928ba35fa9ba$export$35f9e7f2937b6(valid, msg) {
    $a37d928ba35fa9ba$var$validText.textContent = msg;
    if (valid) {
        $a37d928ba35fa9ba$var$validText.style.color = 'green';
        $a37d928ba35fa9ba$var$addFormBtn.disabled = false;
    } else if (valid === null) {
        $a37d928ba35fa9ba$var$validText.style.color = 'rgb(23, 23, 23, 0.9)';
        $a37d928ba35fa9ba$var$addFormBtn.disabled = true;
    } else {
        $a37d928ba35fa9ba$var$validText.style.color = 'red';
        $a37d928ba35fa9ba$var$addFormBtn.disabled = true;
    }
}
function $a37d928ba35fa9ba$export$c1669a529341ad09() {
    $a37d928ba35fa9ba$var$input.value = '';
    $a37d928ba35fa9ba$export$35f9e7f2937b6(null, 'Not more than 25 chars');
}
function $a37d928ba35fa9ba$export$c5e4b84d2ce61726() {
    return $a37d928ba35fa9ba$var$input.value.trim();
}
function $a37d928ba35fa9ba$export$6faa5ff215e98333(spaces, tasks) {
    $a37d928ba35fa9ba$var$spacesList.innerHTML = '';
    // spaceLanding.innerHTML = '';
    if (!spaces) return;
    spaces.forEach((space, index)=>{
        // Count tasks for this space
        const taskCount = tasks.filter((t)=>t.space === space.name).length;
        const li = document.createElement('li');
        li.className = `space--item item--${index}`;
        if (index === spaces.length - 1) li.classList.add('selected');
        li.innerHTML = `
      <div>
        <p class="space--name">${$55e824ff15c161b3$export$9a00dee1beb8f576(space.name)}</p>
        <p class="last--opened">Created: ${$55e824ff15c161b3$export$c4fcf078ecfbfb48(space.time)}</p>
      </div>
      <span class="space--num">${taskCount}</span>
    `;
        $a37d928ba35fa9ba$var$spacesList.appendChild(li);
        li.setAttribute('data-space', space.name);
        li.scrollIntoView({
            behavior: 'auto'
        });
    });
}
function $a37d928ba35fa9ba$export$b920be330ffde316(handler) {
    $a37d928ba35fa9ba$var$openFormBtn.addEventListener('click', handler);
    document.addEventListener('keydown', function(e) {
        if (e.ctrlKey && e.key === 's' || e.ctrlKey && e.key === 'S') {
            e.preventDefault();
            handler();
        }
    });
}
function $a37d928ba35fa9ba$export$23af33bf3b86ca1b(handler) {
    $a37d928ba35fa9ba$var$spaceOverlay.addEventListener('click', handler);
    $a37d928ba35fa9ba$var$form.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') handler();
    });
}
function $a37d928ba35fa9ba$export$7fbc06d7c1beb512(handler) {
    $a37d928ba35fa9ba$var$input.addEventListener('input', (e)=>handler(e.target.value));
}
function $a37d928ba35fa9ba$export$d51ed09a02ad6bc3(handler) {
    $a37d928ba35fa9ba$var$addFormBtn.addEventListener('click', function(e) {
        handler(e);
        if (window.innerWidth < 900) setTimeout(()=>{
            $a37d928ba35fa9ba$var$rightPane.classList.remove('hidden');
            $a37d928ba35fa9ba$var$leftPane.classList.add('hidden');
        }, 500);
    });
    $a37d928ba35fa9ba$var$form.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            handler();
            if (window.innerWidth < 900) setTimeout(()=>{
                $a37d928ba35fa9ba$var$rightPane.classList.remove('hidden');
                $a37d928ba35fa9ba$var$leftPane.classList.add('hidden');
            }, 500);
        }
    });
}



const $6629e82b67c76caf$var$spacesList = document.querySelector('.spaces--list');
function $6629e82b67c76caf$export$1e0753897daa1a7d(spaces, tasks) {
    const selectedSpace = document.querySelector('.selected');
    $6629e82b67c76caf$var$spacesList.innerHTML = '';
    // spaceLanding.innerHTML = '';
    spaces.forEach((space, index)=>{
        // Count tasks for this space
        const taskCount = tasks.filter((t)=>t.space.toLowerCase() === space.name.toLowerCase()).length;
        const li = document.createElement('li');
        li.className = `space--item item--${index}`;
        li.setAttribute('data-space', space.name);
        li.innerHTML = `
      <div>
        <p class="space--name">${$55e824ff15c161b3$export$9a00dee1beb8f576(space.name)}</p>
        <p class="last--opened">Created: ${$55e824ff15c161b3$export$c4fcf078ecfbfb48(space.time)}</p>
      </div>
      <span class="space--num">${taskCount}</span>
    `;
        $6629e82b67c76caf$var$spacesList.appendChild(li);
        if (selectedSpace !== null && selectedSpace.classList.contains(`item--${index}`)) li.classList.add('selected');
    });
}


const $0e601c28389c64f5$var$spacesList = document.querySelector('.spaces--list');
const $0e601c28389c64f5$var$rightPane = document.querySelector('.right--pane');
const $0e601c28389c64f5$var$leftPane = document.querySelector('.left--pane');
const $0e601c28389c64f5$var$backwards = document.querySelector('.backwards');
function $0e601c28389c64f5$export$2e8776145e31b87(selectedEl) {
    // Remove old selection
    document.querySelectorAll('.space--item').forEach((item)=>item.classList.remove('selected'));
    // Highlight new one
    selectedEl.classList.add('selected');
}
function $0e601c28389c64f5$export$347aed8ece261992(handler) {
    $0e601c28389c64f5$var$spacesList.addEventListener('click', function(e) {
        const clicked = e.target.closest('.space--item');
        if (!clicked) return;
        // mobile responsive
        if (window.innerWidth < 900) setTimeout(()=>{
            $0e601c28389c64f5$var$rightPane.classList.remove('hidden');
            $0e601c28389c64f5$var$leftPane.classList.add('hidden');
        }, 300);
        handler(clicked);
    });
}



const $584eddaafeee60ab$var$spaceTitle = document.querySelector('.space-title');
const $584eddaafeee60ab$var$tabs = document.querySelector('.tabs');
const [$584eddaafeee60ab$var$all, $584eddaafeee60ab$var$pending, $584eddaafeee60ab$var$completed, $584eddaafeee60ab$var$archived] = document.querySelectorAll('.tab-num');
const $584eddaafeee60ab$var$backwards = document.querySelector('.backwards');
const $584eddaafeee60ab$var$rightPane = document.querySelector('.right--pane');
const $584eddaafeee60ab$var$leftPane = document.querySelector('.left--pane');
function $584eddaafeee60ab$export$16981a39c25f5cad(selected) {
    $584eddaafeee60ab$var$spaceTitle.textContent = '';
    $584eddaafeee60ab$var$spaceTitle.textContent = $55e824ff15c161b3$export$9a00dee1beb8f576(selected);
}
function $584eddaafeee60ab$export$495e46749433d689(handler) {
    let oldSpaceName;
    $584eddaafeee60ab$var$spaceTitle.addEventListener('click', function() {
        oldSpaceName = $55e824ff15c161b3$export$9a00dee1beb8f576($584eddaafeee60ab$var$spaceTitle.textContent.trim());
    });
    $584eddaafeee60ab$var$spaceTitle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            const newSpaceName = $55e824ff15c161b3$export$9a00dee1beb8f576(e.target.textContent.trim());
            $584eddaafeee60ab$var$spaceTitle.textContent = $55e824ff15c161b3$export$9a00dee1beb8f576(newSpaceName);
            if (newSpaceName === oldSpaceName) {
                $584eddaafeee60ab$var$spaceTitle.blur();
                $584eddaafeee60ab$var$spaceTitle.textContent = oldSpaceName;
                return;
            }
            handler(oldSpaceName, newSpaceName);
        }
    });
}
function $584eddaafeee60ab$export$67a66ee6a2b09b52(handler) {
    $584eddaafeee60ab$var$tabs.addEventListener('click', function(e) {
        // Remove old selection
        document.querySelectorAll('.tab').forEach((item)=>item.classList.remove('selected-tab'));
        // Add selection to current
        const tab = e.target.closest('.tab');
        tab.classList.add('selected-tab');
        handler(tab.dataset.tab);
    });
}
function $584eddaafeee60ab$export$30a3c1af03c3e021() {
    document.querySelectorAll('.tab').forEach((item)=>item.classList.remove('selected-tab'));
    // Add selection to "all" tab
    const tabAll = document.querySelector('.tab');
    tabAll.classList.add('selected-tab');
}
function $584eddaafeee60ab$export$6473c5860e99f7ac(tasks) {
    if (!tasks) {
        $584eddaafeee60ab$var$all.textContent = 0;
        return;
    }
    $584eddaafeee60ab$var$all.textContent = tasks.length;
}
function $584eddaafeee60ab$export$21624210ddb5dfe(tasks) {
    if (!tasks) {
        $584eddaafeee60ab$var$pending.textContent = 0;
        return;
    }
    $584eddaafeee60ab$var$pending.textContent = tasks.length;
}
function $584eddaafeee60ab$export$6cef392a8bb4edc2(tasks) {
    if (!tasks) {
        $584eddaafeee60ab$var$completed.textContent = 0;
        return;
    }
    $584eddaafeee60ab$var$completed.textContent = tasks.length;
}
function $584eddaafeee60ab$export$c1d278be0a8c9cf9(tasks) {
    if (!tasks) {
        $584eddaafeee60ab$var$archived.textContent = 0;
        return;
    }
    $584eddaafeee60ab$var$archived.textContent = tasks.length;
}
// Mobile responsive
if (window.innerWidth < 900) {
    const backwards = document.querySelector('.backwards');
    backwards.addEventListener('click', function() {
        $584eddaafeee60ab$var$rightPane.classList.add('hidden');
        $584eddaafeee60ab$var$leftPane.classList.remove('hidden');
    });
}


// //////////////////////////////////// Add Spaces
// Open Form
const $bcd1f1b99c6ae21e$var$openForm = function() {
    $a37d928ba35fa9ba$export$22bab4bbe1f35723();
    const { valid: valid, msg: msg } = $7b94c335d9c1ff80$export$f03cab61d61a42f0($a37d928ba35fa9ba$export$c5e4b84d2ce61726(), 25);
    $a37d928ba35fa9ba$export$35f9e7f2937b6(valid, msg);
};
// Close Form
const $bcd1f1b99c6ae21e$var$closeForm = function() {
    $a37d928ba35fa9ba$export$ae0ccaae42dee9bc();
    $a37d928ba35fa9ba$export$c1669a529341ad09();
};
// Validate input while typing
const $bcd1f1b99c6ae21e$var$validateTypingInput = function(value) {
    const { valid: valid, msg: msg } = $7b94c335d9c1ff80$export$f03cab61d61a42f0(value, 25);
    $a37d928ba35fa9ba$export$35f9e7f2937b6(valid, msg);
};
// Add new Space
const $bcd1f1b99c6ae21e$var$addNewSpace = function() {
    const newSpace = $a37d928ba35fa9ba$export$c5e4b84d2ce61726();
    const { valid: valid } = $7b94c335d9c1ff80$export$f03cab61d61a42f0(newSpace, 25);
    if (!valid) return;
    const success = $8a68e8e5f5b6a7df$export$c672d36cc05d8a31(newSpace);
    if (!success) {
        alert(`${newSpace} already exists!`);
        $a37d928ba35fa9ba$export$22bab4bbe1f35723();
        return;
    }
    // updateSpaces
    $a37d928ba35fa9ba$export$6faa5ff215e98333(success, $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks);
    $a37d928ba35fa9ba$export$c1669a529341ad09();
    $a37d928ba35fa9ba$export$ae0ccaae42dee9bc();
    // ******************8 taskView **********************
    $efdbc318bab6ae71$export$965f107e1da09ee7($8b9580027b625b19$export$4b713e253325a1b6());
    // ****************** tabView **********************
    $584eddaafeee60ab$export$16981a39c25f5cad($7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace);
    $584eddaafeee60ab$export$30a3c1af03c3e021();
    $584eddaafeee60ab$export$6473c5860e99f7ac();
    $584eddaafeee60ab$export$21624210ddb5dfe();
    $584eddaafeee60ab$export$6cef392a8bb4edc2();
    $584eddaafeee60ab$export$c1d278be0a8c9cf9();
};
// Select Space
const $bcd1f1b99c6ae21e$var$selectSpaceController = function(clicked) {
    $0e601c28389c64f5$export$2e8776145e31b87(clicked);
    $8a68e8e5f5b6a7df$export$cfcf789129734d0c(clicked);
    $584eddaafeee60ab$export$16981a39c25f5cad($7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedSpace);
    // ******************8 taskView **********************
    $efdbc318bab6ae71$export$965f107e1da09ee7($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$30a3c1af03c3e021();
    $584eddaafeee60ab$export$6473c5860e99f7ac($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$21624210ddb5dfe($8b9580027b625b19$export$461260a351dd1159());
    $584eddaafeee60ab$export$6cef392a8bb4edc2($8b9580027b625b19$export$7a201e616c9e1a4d());
    $584eddaafeee60ab$export$c1d278be0a8c9cf9($8b9580027b625b19$export$ecd6bf12cc32669b());
};
function $bcd1f1b99c6ae21e$export$7d43d807cce561db() {
    $6629e82b67c76caf$export$1e0753897daa1a7d($7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces, $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks);
    $a37d928ba35fa9ba$export$b920be330ffde316($bcd1f1b99c6ae21e$var$openForm);
    $a37d928ba35fa9ba$export$23af33bf3b86ca1b($bcd1f1b99c6ae21e$var$closeForm);
    $a37d928ba35fa9ba$export$d51ed09a02ad6bc3($bcd1f1b99c6ae21e$var$addNewSpace);
    $a37d928ba35fa9ba$export$7fbc06d7c1beb512($bcd1f1b99c6ae21e$var$validateTypingInput);
    $0e601c28389c64f5$export$347aed8ece261992($bcd1f1b99c6ae21e$var$selectSpaceController);
}





// DOM selections
const [$90f1e01bb5e8bb76$var$openFormBtn, $90f1e01bb5e8bb76$var$addFormBtn] = document.querySelectorAll('.btn--2');
const [$90f1e01bb5e8bb76$var$spaceOverlay, $90f1e01bb5e8bb76$var$taskOverlay] = document.querySelectorAll('.overlay');
const $90f1e01bb5e8bb76$var$form = document.querySelector('.form--task');
const $90f1e01bb5e8bb76$var$input = document.querySelector('.task--input');
const $90f1e01bb5e8bb76$var$validText = document.querySelector('.task-text');
function $90f1e01bb5e8bb76$export$22bab4bbe1f35723() {
    $90f1e01bb5e8bb76$var$addFormBtn.classList.remove('hidden');
    $90f1e01bb5e8bb76$var$openFormBtn.classList.add('hidden');
    $90f1e01bb5e8bb76$var$form.classList.replace('hidden', 'block-task-input');
    $90f1e01bb5e8bb76$var$taskOverlay.classList.remove('hidden');
    $90f1e01bb5e8bb76$var$input.focus();
}
function $90f1e01bb5e8bb76$export$ae0ccaae42dee9bc() {
    $90f1e01bb5e8bb76$var$addFormBtn.classList.add('hidden');
    $90f1e01bb5e8bb76$var$openFormBtn.classList.remove('hidden');
    $90f1e01bb5e8bb76$var$form.classList.replace('block-task-input', 'hidden');
    $90f1e01bb5e8bb76$var$taskOverlay.classList.add('hidden');
}
function $90f1e01bb5e8bb76$export$35f9e7f2937b6(valid, msg) {
    $90f1e01bb5e8bb76$var$validText.textContent = msg;
    if (valid) {
        $90f1e01bb5e8bb76$var$validText.style.color = 'green';
        $90f1e01bb5e8bb76$var$addFormBtn.disabled = false;
    } else if (valid === null) {
        $90f1e01bb5e8bb76$var$validText.style.color = 'rgb(23, 23, 23, 0.9)';
        $90f1e01bb5e8bb76$var$addFormBtn.disabled = true;
    } else {
        $90f1e01bb5e8bb76$var$validText.style.color = 'red';
        $90f1e01bb5e8bb76$var$addFormBtn.disabled = true;
    }
}
function $90f1e01bb5e8bb76$export$c1669a529341ad09() {
    $90f1e01bb5e8bb76$var$input.value = '';
    $90f1e01bb5e8bb76$export$35f9e7f2937b6(null, 'Not more than 200 chars');
}
function $90f1e01bb5e8bb76$export$c5e4b84d2ce61726() {
    return $90f1e01bb5e8bb76$var$input.value.trim();
}
function $90f1e01bb5e8bb76$export$b920be330ffde316(handler) {
    $90f1e01bb5e8bb76$var$openFormBtn.addEventListener('click', function(e) {
        e.preventDefault();
        handler();
    });
    document.addEventListener('keydown', function(e) {
        if (e.ctrlKey && e.key === 'q' || e.ctrlKey && e.key === 'Q') {
            e.preventDefault();
            handler();
        }
    });
}
function $90f1e01bb5e8bb76$export$23af33bf3b86ca1b(handler) {
    $90f1e01bb5e8bb76$var$taskOverlay.addEventListener('click', handler);
    $90f1e01bb5e8bb76$var$form.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') handler();
    });
}
function $90f1e01bb5e8bb76$export$7fbc06d7c1beb512(handler) {
    $90f1e01bb5e8bb76$var$input.addEventListener('input', (e)=>handler(e.target.value));
}
function $90f1e01bb5e8bb76$export$e1aa5e1e4a1609c1(handler) {
    $90f1e01bb5e8bb76$var$addFormBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        handler(e);
    });
    $90f1e01bb5e8bb76$var$form.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            handler();
        }
    });
}





const $47232e4e1a96c503$var$taskList = document.querySelector('.task-list');
function $47232e4e1a96c503$export$4d9991bc6d1fe480(handler) {
    // Select DomEl
    $47232e4e1a96c503$var$taskList.addEventListener('click', function(e) {
        if (!e.target.closest('.done')) return;
        const item = e.target.closest('.left');
        const taskName = item.querySelector('.task-name');
        const completedIcon = item.querySelector('.done');
        handler(taskName.textContent.trim(), 'completed');
    });
}
function $47232e4e1a96c503$export$5c192d29dd8a42bc(handler) {
    // Select DomEl
    $47232e4e1a96c503$var$taskList.addEventListener('click', function(e) {
        if (!e.target.classList.contains('archive')) return;
        const taskItem = e.target.closest('.task');
        const taskName = taskItem.querySelector('.task-name');
        const archiveIcon = taskItem.querySelector('.archive');
        handler(taskName.textContent.trim(), 'archived');
    });
}
function $47232e4e1a96c503$export$f08d315250e1aa23(handler) {
    $47232e4e1a96c503$var$taskList.addEventListener('click', function(e) {
        if (!e.target.classList.contains('delete')) return;
        const taskItem = e.target.closest('.task');
        const taskName = taskItem.querySelector('.task-name');
        const deleteIcon = taskItem.querySelector('.delete');
        handler(taskName.textContent.trim());
    });
}
function $47232e4e1a96c503$export$8ad8cae9b4b277bd(handler) {
    $47232e4e1a96c503$var$taskList.addEventListener('click', function(e) {
        if (!e.target.classList.contains('task-name')) return;
        const selectedTask = e.target;
        const oldTaskName = selectedTask.textContent.trim();
        selectedTask.addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                const newTaskName = $55e824ff15c161b3$export$7d4e79dfece53960(event.target.textContent.trim());
                if (oldTaskName === newTaskName) {
                    selectedTask.blur();
                    selectedTask.textContent = oldTaskName;
                    return;
                }
                handler(oldTaskName, newTaskName);
            }
        });
    });
}



const $e3f5818596a061bb$var$taskList = document.querySelector('.task-list');
const $e3f5818596a061bb$export$fe6f2861bde86ed = function(tasks) {
    $e3f5818596a061bb$var$taskList.innerHTML = '';
    if (!tasks) return;
    tasks.forEach((task, index)=>{
        const li = document.createElement('li');
        li.innerHTML = `
                  <div>
                    <span class="left">
                      <div class="circle done" title='complete'>
                          <span><i class="fa-solid fa-check tick"></i></span>
                      </div>

                      <p class="task-name ${task.archived ? 'grey-text' : ''}">
                        ${$55e824ff15c161b3$export$7d4e79dfece53960(task.name)}
                      </p>
                    </span>
                    <div class="task--details">
                    <p class="date"><i class="fa-regular fa-clock"></i>${$55e824ff15c161b3$export$c4fcf078ecfbfb48(task.time)}</p>
                      <p class=${task.edited ? 'tag' : 'hidden'}>Edited</p>
                      <p class=${task.archived ? 'tag' : 'hidden'}>Archived</p>
                    </div>
                  </div>
                  <div class="right">
                    <div class="circle disactive"></div>
                    <div class="circle disactive"></div>
                  </div>
    `;
        li.classList.add('task', `${index}`);
        $e3f5818596a061bb$var$taskList.appendChild(li);
    });
};



const $e4daed113498a809$var$taskList = document.querySelector('.task-list');
const $e4daed113498a809$export$5e9ad24a4921f5c6 = function(tasks) {
    $e4daed113498a809$var$taskList.innerHTML = '';
    if (!tasks) return;
    tasks.forEach((task, index)=>{
        const li = document.createElement('li');
        li.innerHTML = `
                  <div>
                    <span class="left">
                      <div class="circle done full" title='uncomplete'>
                          <span><i class="fa-solid fa-check tick"></i></span>
                      </div>

                      <p class="task-name ${task.completed && 'strike'}" >
                        ${$55e824ff15c161b3$export$7d4e79dfece53960(task.name)}
                      </p>
                    </span>
                    <div class="task--details">
                    <p class="date"><i class="fa-regular fa-clock"></i>${$55e824ff15c161b3$export$c4fcf078ecfbfb48(task.time)}</p>
                      <p class=${task.edited ? 'tag' : 'hidden'}>Edited</p>
                      <p class=${task.archived ? 'tag' : 'hidden'}>Archived</p>
                    </div>
                  </div>
                  <div class="right">
                    <div class="circle disactive"></div>
                    <div class="circle disactive"></div>
                  </div>
    `;
        li.classList.add('task', `${index}`);
        $e4daed113498a809$var$taskList.appendChild(li);
    });
};



const $d2ccbc900ce0876e$var$taskList = document.querySelector('.task-list');
const $d2ccbc900ce0876e$export$b034274d9bd852c5 = function(tasks) {
    $d2ccbc900ce0876e$var$taskList.innerHTML = '';
    if (!tasks) return;
    tasks.forEach((task, index)=>{
        const li = document.createElement('li');
        li.innerHTML = `
                  <div>
                    <span class="left">
                      <div class="circle done" title="complete">
                          <span><i class="fa-solid fa-check tick"></i></span>
                      </div>

                      <p class="task-name ${task.archived ? 'grey-text' : ''}" >
                        ${$55e824ff15c161b3$export$7d4e79dfece53960(task.name)}
                      </p>
                    </span>
                    <div class="task--details">
                      <p class="date"><i class="fa-regular fa-clock"></i>${$55e824ff15c161b3$export$c4fcf078ecfbfb48(task.time)}</p>
                      <p class=${task.edited ? 'tag' : 'hidden'}>Edited</p>
                      <p class="tag">Archived</p>
                    </div>
                  </div>
                  <div class="right">
                    <div class="circle archive" title="archive"></div>
                    <div class="circle disactive"></div>
                  </div>
    `;
        li.classList.add('task', `${index}`);
        $d2ccbc900ce0876e$var$taskList.appendChild(li);
    });
};


// Open Form
const $49f2ff35852f72a9$var$openForm = function() {
    $90f1e01bb5e8bb76$export$22bab4bbe1f35723();
    const { valid: valid, msg: msg } = $7b94c335d9c1ff80$export$776c9bc84f6ac10($90f1e01bb5e8bb76$export$c5e4b84d2ce61726(), 250);
    $90f1e01bb5e8bb76$export$35f9e7f2937b6(valid, msg);
};
// Close Form
const $49f2ff35852f72a9$var$closeForm = function() {
    $90f1e01bb5e8bb76$export$ae0ccaae42dee9bc();
    $90f1e01bb5e8bb76$export$c1669a529341ad09();
};
// Validate input while typing
const $49f2ff35852f72a9$var$validateTypingInput = function(value) {
    const { valid: valid, msg: msg } = $7b94c335d9c1ff80$export$776c9bc84f6ac10(value, 250);
    $90f1e01bb5e8bb76$export$35f9e7f2937b6(valid, msg);
};
// Add new task
const $49f2ff35852f72a9$var$addTask = function() {
    const newTask = $90f1e01bb5e8bb76$export$c5e4b84d2ce61726();
    const { valid: valid } = $7b94c335d9c1ff80$export$776c9bc84f6ac10(newTask, 250);
    if (!valid) return;
    const success = $8b9580027b625b19$export$210cf76140947b0c(newTask);
    if (!success) {
        alert(`${newTask} already exists!`);
        $90f1e01bb5e8bb76$export$22bab4bbe1f35723();
        return;
    }
    $efdbc318bab6ae71$export$965f107e1da09ee7($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$6473c5860e99f7ac($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$21624210ddb5dfe($8b9580027b625b19$export$461260a351dd1159());
    $584eddaafeee60ab$export$6cef392a8bb4edc2($8b9580027b625b19$export$7a201e616c9e1a4d());
    $584eddaafeee60ab$export$c1d278be0a8c9cf9($8b9580027b625b19$export$ecd6bf12cc32669b());
    $584eddaafeee60ab$export$30a3c1af03c3e021();
    $90f1e01bb5e8bb76$export$c1669a529341ad09();
    $90f1e01bb5e8bb76$export$ae0ccaae42dee9bc();
    // **************************** Space View **************************
    $6629e82b67c76caf$export$1e0753897daa1a7d($7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces, $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks);
};
// Edit space name from tasks pane
$584eddaafeee60ab$export$495e46749433d689((oldSpaceName, newSpaceName)=>{
    $8b9580027b625b19$export$6937fadb06c56e4c(oldSpaceName, newSpaceName);
    $efdbc318bab6ae71$export$965f107e1da09ee7($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$6473c5860e99f7ac($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$21624210ddb5dfe($8b9580027b625b19$export$461260a351dd1159());
    $584eddaafeee60ab$export$6cef392a8bb4edc2($8b9580027b625b19$export$7a201e616c9e1a4d());
    $584eddaafeee60ab$export$c1d278be0a8c9cf9($8b9580027b625b19$export$ecd6bf12cc32669b());
    $584eddaafeee60ab$export$30a3c1af03c3e021();
    // ************* space View ***********************
    $6629e82b67c76caf$export$1e0753897daa1a7d($7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces, $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks);
});
// Select tab
const $49f2ff35852f72a9$var$selectTab = function() {
    $584eddaafeee60ab$export$67a66ee6a2b09b52((tab)=>{
        $8b9580027b625b19$export$9f2575a093d7aa7b(tab);
        if (tab === 'all') $efdbc318bab6ae71$export$965f107e1da09ee7($8b9580027b625b19$export$d1f442602a91e7cc());
        else if (tab === 'pending') $e3f5818596a061bb$export$fe6f2861bde86ed($8b9580027b625b19$export$461260a351dd1159());
        else if (tab === 'completed') $e4daed113498a809$export$5e9ad24a4921f5c6($8b9580027b625b19$export$7a201e616c9e1a4d());
        else if (tab === 'archived') $d2ccbc900ce0876e$export$b034274d9bd852c5($8b9580027b625b19$export$ecd6bf12cc32669b());
    });
};
$49f2ff35852f72a9$var$selectTab();
///////////////////////////////////////////////////////////////
// task actions
// ---- Mark as completed and Uncompleted
$47232e4e1a96c503$export$4d9991bc6d1fe480((taskName, action)=>{
    const completedState = $8b9580027b625b19$export$ade48d0de42a8766(taskName, action);
    if (!completedState && $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedTab === 'completed') $e4daed113498a809$export$5e9ad24a4921f5c6($8b9580027b625b19$export$7a201e616c9e1a4d());
    if (completedState && $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedTab === 'all') $efdbc318bab6ae71$export$965f107e1da09ee7($8b9580027b625b19$export$d1f442602a91e7cc());
    if (completedState && $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedTab === 'pending') $e3f5818596a061bb$export$fe6f2861bde86ed($8b9580027b625b19$export$461260a351dd1159());
    if (completedState && $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedTab === 'archived') $d2ccbc900ce0876e$export$b034274d9bd852c5($8b9580027b625b19$export$ecd6bf12cc32669b());
    $584eddaafeee60ab$export$6473c5860e99f7ac($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$21624210ddb5dfe($8b9580027b625b19$export$461260a351dd1159());
    $584eddaafeee60ab$export$6cef392a8bb4edc2($8b9580027b625b19$export$7a201e616c9e1a4d());
    $584eddaafeee60ab$export$c1d278be0a8c9cf9($8b9580027b625b19$export$ecd6bf12cc32669b());
});
$47232e4e1a96c503$export$5c192d29dd8a42bc((taskName, action)=>{
    const archivedState = $8b9580027b625b19$export$ade48d0de42a8766(taskName, action);
    if (!archivedState && $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedTab === 'archived') $d2ccbc900ce0876e$export$b034274d9bd852c5($8b9580027b625b19$export$ecd6bf12cc32669b());
    if (archivedState && $7b94c335d9c1ff80$export$ca000e230c0caa3e.selectedTab === 'all') $efdbc318bab6ae71$export$965f107e1da09ee7($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$6473c5860e99f7ac($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$21624210ddb5dfe($8b9580027b625b19$export$461260a351dd1159());
    $584eddaafeee60ab$export$6cef392a8bb4edc2($8b9580027b625b19$export$7a201e616c9e1a4d());
    $584eddaafeee60ab$export$c1d278be0a8c9cf9($8b9580027b625b19$export$ecd6bf12cc32669b());
});
// Deleting a task
$47232e4e1a96c503$export$f08d315250e1aa23((taskName)=>{
    $8b9580027b625b19$export$f08d315250e1aa23(taskName);
    $efdbc318bab6ae71$export$965f107e1da09ee7($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$6473c5860e99f7ac($8b9580027b625b19$export$d1f442602a91e7cc());
    $584eddaafeee60ab$export$21624210ddb5dfe($8b9580027b625b19$export$461260a351dd1159());
    // ************* space View ***********************
    $6629e82b67c76caf$export$1e0753897daa1a7d($7b94c335d9c1ff80$export$ca000e230c0caa3e.spaces, $7b94c335d9c1ff80$export$ca000e230c0caa3e.tasks);
});
// Editing a task
$47232e4e1a96c503$export$8ad8cae9b4b277bd((oldTaskName, newTaskName)=>{
    $8b9580027b625b19$export$7929b2426b44fc90(oldTaskName, newTaskName);
    $efdbc318bab6ae71$export$965f107e1da09ee7($8b9580027b625b19$export$d1f442602a91e7cc());
});
function $49f2ff35852f72a9$export$457135dfc5653411() {
    $90f1e01bb5e8bb76$export$b920be330ffde316($49f2ff35852f72a9$var$openForm);
    $90f1e01bb5e8bb76$export$23af33bf3b86ca1b($49f2ff35852f72a9$var$closeForm);
    $90f1e01bb5e8bb76$export$e1aa5e1e4a1609c1($49f2ff35852f72a9$var$addTask);
    $90f1e01bb5e8bb76$export$7fbc06d7c1beb512($49f2ff35852f72a9$var$validateTypingInput);
}


const $fcb1b0c34fc0382d$var$rightPane = document.querySelector('.right--pane');
const $fcb1b0c34fc0382d$var$leftPane = document.querySelector('.left--pane');
// mobile
if (window.innerWidth < 900) $fcb1b0c34fc0382d$var$rightPane.classList.add('hidden');


$bcd1f1b99c6ae21e$export$7d43d807cce561db();
$49f2ff35852f72a9$export$457135dfc5653411();


//# sourceMappingURL=app.b8c9d1cc.js.map
